/* Easter Egg: ein einzelner Buchstabe in weiß-rot gestreift, der fest an seiner Stelle bleibt.
   Wer ihn anklickt, bekommt den Gutschein-Link für Slimeside.
   Pro Person gibt es das Egg nur auf EINER Seite (wird beim ersten Besuch zufällig aus SEITEN gewählt),
   nur in den unteren 75 Prozent der Seite, und nur bis es gefunden wurde. Alle anderen Seiten bleiben leer. */
(function () {
  'use strict';
  var TX = window.SH_EGG_I18N || { aria: 'Überraschung', dialog: 'Gutschein gefunden', title: 'Gefunden! 🐌', text: 'Du hast unseren versteckten Buchstaben erwischt. Hier ist dein Gutschein für Slimeside (Code: {code}).', link: 'Gutschein einlösen', close: 'Schließen' };
  var URL_GUTSCHEIN = 'https://slimeside.de/discount/Schnecken-Hilfe';
  var CODE = 'Schnecken-Hilfe';
  // Auf diesen Seiten kann das Egg erscheinen. Die Startseite und alles andere bleibt leer.
  var SEITEN = ['/pages/ueber-uns', '/pages/faq', '/pages/spenden', '/pages/patenschaft', '/pages/adopt', '/pages/mitglied-werden'];
  var UNTERER_TEIL = 0.25; // nur Text, der weiter unten als dieser Anteil der Seitenhöhe steht (0.25 = untere 75 Prozent)
  var meinePfad = window.location.pathname.replace(/\/+$/, '').toLowerCase().replace(/^\/(en|fr|it|nl|pl|es|cs)(?=\/|$)/, '');
  try {
    if (window.localStorage.getItem('shEggGefunden') === '1') return;
    var gewaehlt = window.localStorage.getItem('shEggSeite');
    if (!gewaehlt || SEITEN.indexOf(gewaehlt) === -1) {
      gewaehlt = SEITEN[Math.floor(Math.random() * SEITEN.length)];
      window.localStorage.setItem('shEggSeite', gewaehlt);
    }
    if (gewaehlt !== meinePfad) return;
  } catch (e) { return; }
  if (window.__shEgg) return;
  window.__shEgg = true;
  var main = document.querySelector('main');
  if (!main) return;

  var BLOCK = 'script,style,noscript,a,button,input,textarea,select,label,svg,video,iframe,dialog,form,nav,header,footer,[contenteditable],[aria-hidden="true"],.sh-egg,.sh-egg-popup,[data-no-egg]';
  var BUCHSTABE = /[A-Za-zÄÖÜäöüß]/;
  var span = null;

  function imUnterenTeil(el) {
    var r = el.getBoundingClientRect();
    if (!(r.width > 0 && r.height > 0)) return false;
    var hoehe = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
    return (r.top + window.pageYOffset) > hoehe * UNTERER_TEIL;
  }

  function kandidaten() {
    var liste = [];
    var elemente = main.querySelectorAll('p, li, h2, h3, h4, blockquote, figcaption, dd, dt, td');
    Array.prototype.forEach.call(elemente, function (el) {
      if (el.closest(BLOCK) && el.closest(BLOCK) !== el) return;
      if (el.closest('a, button, form, nav, [data-no-egg]')) return;
      if (!imUnterenTeil(el)) return;
      var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
      var n;
      while ((n = w.nextNode())) {
        var p = n.parentNode;
        if (!p || (p.closest && p.closest(BLOCK))) continue;
        if (n.nodeValue.trim().length < 4) continue;
        liste.push(n);
      }
    });
    return liste;
  }

  // Zufallswerte werden einmal pro Person gespeichert, damit der Buchstabe bei jedem Besuch an derselben Stelle steht
  function festerWert(name) {
    var w = parseFloat(window.localStorage.getItem(name));
    if (isNaN(w) || w < 0 || w >= 1) {
      w = Math.random();
      try { window.localStorage.setItem(name, String(w)); } catch (e) { /* egal */ }
    }
    return w;
  }

  function einmalSetzen() {
    if (document.querySelector('.sh-egg')) return;
    var liste = kandidaten();
    if (!liste.length) return;
    var knoten = liste[Math.floor(festerWert('shEggA') * liste.length)];
    var text = knoten.nodeValue;
    var treffer = [];
    for (var i = 0; i < text.length; i++) if (BUCHSTABE.test(text.charAt(i))) treffer.push(i);
    if (!treffer.length) return;
    var pos = treffer[Math.floor(festerWert('shEggB') * treffer.length)];
    var s = document.createElement('span');
    s.className = 'sh-egg';
    s.textContent = text.charAt(pos);
    s.setAttribute('role', 'button');
    s.setAttribute('tabindex', '-1');
    s.setAttribute('aria-label', TX.aria);
    var davor = document.createTextNode(text.slice(0, pos));
    var danach = document.createTextNode(text.slice(pos + 1));
    var eltern = knoten.parentNode;
    eltern.insertBefore(davor, knoten);
    eltern.insertBefore(s, knoten);
    eltern.insertBefore(danach, knoten);
    eltern.removeChild(knoten);
    span = s;
  }

  var popup = null;
  function schliessen() {
    if (popup && popup.parentNode) popup.parentNode.removeChild(popup);
    popup = null;
  }

  function zeigePopup() {
    if (popup) return;
    try { window.localStorage.setItem('shEggGefunden', '1'); } catch (e) { /* egal */ }
    popup = document.createElement('div');
    popup.className = 'sh-egg-popup';
    popup.setAttribute('role', 'dialog');
    popup.setAttribute('aria-label', TX.dialog);
    var h = document.createElement('p');
    h.className = 'sh-egg-popup__title';
    h.textContent = TX.title;
    var t = document.createElement('p');
    t.textContent = TX.text.split('{code}').join(CODE);
    var a = document.createElement('a');
    a.className = 'sh-egg-popup__link';
    a.href = URL_GUTSCHEIN;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    a.textContent = TX.link;
    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'sh-egg-popup__close';
    x.textContent = TX.close;
    x.addEventListener('click', schliessen);
    popup.appendChild(h);
    popup.appendChild(t);
    popup.appendChild(a);
    popup.appendChild(x);
    document.body.appendChild(popup);
    a.focus();
  }

  // Beim Klick: als gefunden merken und den Buchstaben sofort wieder zu normalem Text machen
  function buchstabeEntfernen(el) {
    var eltern = el.parentNode;
    if (!eltern) return;
    eltern.replaceChild(document.createTextNode(el.textContent), el);
    eltern.normalize();
  }

  document.addEventListener('click', function (e) {
    var treffer = e.target.closest && e.target.closest('.sh-egg');
    if (!treffer) return;
    e.preventDefault();
    zeigePopup();
    buchstabeEntfernen(treffer);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') schliessen(); });

  // Erst setzen, wenn die Seite fertig aufgebaut ist (die Seitenhöhe muss stimmen)
  if (document.readyState === 'complete') window.setTimeout(einmalSetzen, 400);
  else window.addEventListener('load', function () { window.setTimeout(einmalSetzen, 400); });
})();
